






import { Vue, Component, Prop, Watch } from "vue-property-decorator"
import PaymentBase from './PaymentBase'
import * as TinabaAPI from '@/common/TinabaAPI'
import { getformattedLocale } from '@/i18n'
import PaymentButton from './PaymentButton.vue'

@Component({
  components: {
    PaymentButton,
  }
})
export default class PaypalPay extends PaymentBase {
  @Prop({ default: null }) readonly beforePaypalPay!: any;

  processing: boolean = false
  paypalActions = null
  errorNote: string | null = null

  initPaypal () {
    window.paypal.Buttons({
      locale: getformattedLocale(),
      style: {
        height: 45,
        layout:  'horizontal',
        size: 'responsive',
        shape: 'rect',
        color: 'gold'
      },
      createOrder: (data: any, actions: any) => {
        return new Promise((resolve, reject) => {
          this.beforePaypalPay().then(() => {
            this.$tinabaAPI.$vas.createPaypalCheckout(this.payment.id, 'WALLET').then((data: any) => {
              if (data.message) {
                this.errorNote = data.message
                return reject(null)
              }
              this.setGlobalLoading()
              return resolve(data.externalTransactionId)
            })
          })
        })
      },
      onInit: (data: any, actions: any) => {
        this.paypalActions = actions
      },
      onError: () => {
        this.processing = false
        this.unsetGlobalLoading()
      },
      onCancel: () => {
        this.processing = false
        this.unsetGlobalLoading()
      },
      onApprove: (data: any, actions: any) => {
        return this.$tinabaAPI.$vas.confirmPaypalCheckout({ ...data, externalTransactionId: data.orderID })
        .then(async (data: any) => {
          this.unsetGlobalLoading()
          await this.triggerPoll()
          if (!data.res.ok) {
            this.errorNote = 'Something went wrong'
          }
        })
      }
    }).render(this.$refs.forpaypal)
  }

  mounted () {
    this.initPaypal()
  }
}
